export class Recipe {
	constructor (attributes) {
		var recipe = attributes

		for (let key in recipe) {
			this[key] = recipe[key]
		}

		if (this.ingredients) {
			this.ingredients.forEach(ingredient => {
				if (!special(ingredient.id)) return

				ingredient.isSpecial = true
				ingredient.link = special(ingredient.id).routerLinkName
			})
		}

		if (this.nutrition) {
			this.nutrition.calories = Math.round(this.nutrition.calories)
			this.nutrition.joules = Math.round(this.nutrition.joules)
		}

	}

	isNutritioinCompleted () {
		if (!this.nutrition) return false

		return nutritionFields.every(r => this.nutrition[r] != null)
	}
}

var nutritionFields = ['calories', 'saturates', 'fat', 'carbohydrate', 'sugars', 'fibre', 'protein', 'salt']

var specialIngredients = [
	{
		routerLinkName: 'legumotti',
		ingredientId: [498, 499, 500]
	},

	{
		routerLinkName: 'lenticchie',
		ingredientId: [503]
	},

	{
		routerLinkName: 'perugina',
		ingredientId: [20, 431, 440, 444]
	},

	{
		routerLinkName: 'spaghetti-di-verdure',
		ingredientId: [525, 526, 527, 528, 530]
	},

	{
		routerLinkName: 'nutracentis',
		ingredientId: [575, 576, 567, 565, 566]
	}
]

const special = (id) => {
	return specialIngredients.find(r => r.ingredientId.indexOf(id) !== -1)
}
